import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const medicineDateRoutes = [
  {
    path: "/directories/medicine-date",
    name: "MedicineDateList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "medicineDate" */ "./components/List"),
  },
];
